var render = function render(_c, _vm) {
  return _c(
    "section",
    [
      _c(
        "wa-question-and-answer",
        { attrs: { id: "icons", title: "Icons - CC BY 4.0 License" } },
        [
          _vm._v("\n    In the Font Awesome Free download, the\n    "),
          _c(
            "a",
            {
              attrs: {
                href: "https://creativecommons.org/licenses/by/4.0/",
                target: "_blank",
              },
            },
            [_vm._v("\n      CC BY 4.0 license\n    ")]
          ),
          _vm._v(
            "\n    applies to all icons packaged as .svg and .js files types.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        { attrs: { id: "fonts", title: "Fonts - SIL OFL 1.1 License" } },
        [
          _vm._v("\n    In the Font Awesome Free download, the\n    "),
          _c(
            "a",
            {
              attrs: { href: "https://scripts.sil.org/OFL", target: "_blank" },
            },
            [_vm._v("\n      SIL OFL license\n    ")]
          ),
          _vm._v(
            "\n    applies to all icons packaged as web and desktop font files.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "wa-question-and-answer",
        { attrs: { id: "code", title: "Code - MIT License" } },
        [
          _vm._v("\n    In the Font Awesome Free download, the\n    "),
          _c(
            "a",
            {
              attrs: {
                href: "https://opensource.org/licenses/MIT",
                target: "_blank",
              },
            },
            [_vm._v("\n      MIT license\n    ")]
          ),
          _vm._v("\n    applies to all non-font and non-icon files.\n  "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }